// extracted by mini-css-extract-plugin
export default {"root":"_34qtuScN","dropdown":"_20XKsAfR"};